<template>
  <form
    ref="form"
    method="post"
    @submit.prevent="onSubmit"
    :id="formId"
    :class="['form', formClasses, { 'is-sending': isFormSending, 'is-success': isFormSent }]"
    :data-type="formEvent"
    novalidate
  >
    <div v-html="xsrfFormHtml"></div>

    <div class="form__row" v-if="showThisField('name')">
      <base-input type="text" class="input" ref="name" name="name" placeholder="Имя" v-model="form.name" required />
    </div>

    <div class="form__row" v-if="showThisField('last_name')">
      <base-input
        type="text"
        class="input"
        ref="last_name"
        name="last_name"
        placeholder="Фамилия"
        v-model="form.last_name"
        required
      />
    </div>

    <div class="form__row" v-if="showThisField('phone')">
      <base-input
        v-model="form.phone"
        type="tel"
        class="input"
        ref="phone"
        name="phone"
        placeholder="Телефон"
        maxlength="25"
        required
      />
    </div>

    <div class="form__row" v-if="showThisField('email')">
      <base-input
        v-model="form.email"
        type="email"
        class="input"
        ref="email"
        name="email"
        placeholder="Эл. почта"
        required
      />
    </div>

    <div class="form__row" v-if="showThisField('position')">
      <base-input
        v-model="form.position"
        type="text"
        class="input"
        ref="position"
        name="position"
        placeholder="Должность"
        required
      />
    </div>

    <div class="form__row" v-if="showThisField('company')">
      <base-input
        v-model="form.company"
        type="text"
        class="input"
        ref="company"
        name="company"
        placeholder="Компания"
        minlength="2"
        required
      />
    </div>

    <div class="form__row" v-if="showThisField('client_status')">
      <label class="checkbox">
        <input type="checkbox" v-model="form.client_status" ref="client_status" name="client_status" />
        <span class="checkmark"></span>
        Я&nbsp;&mdash; клиент Хантфлоу
      </label>
    </div>

    <span class="error-message" v-if="isSubmittedError">
      Ошибка отправки данных.<br />
      Пожалуйста, попробуйте еще раз.
    </span>

    <base-button
      type="submit"
      class="form__submit button button--block button--xl button--primary"
      :data-event="formEvent"
      >{{ formTextButton }}</base-button
    >

    <div class="container" v-if="!isObjectEmpty(formSuccessMessageProps)">
      <div class="form-success">
        <FormSuccessMessage
          ref="formSuccessMessage"
          :title="formSuccessMessageProps.title"
          :caption="formSuccessMessageProps.caption"
          :form-type="formSuccessMessageProps.formType"
          :telegram-info="formSuccessMessageProps.telegramInfo"
          :telegram-link="telegramLink"
        />
      </div>
    </div>
  </form>
</template>

<script>
import Cookies from 'js-cookie';
import { BaseInput, BaseButton } from 'huntkit';
import 'huntkit/hunt-kit.css';
import FormUtils from './FormUtils.js';
import FormSuccessMessage from '~scripts/blocks/vue/FormSuccessMessage.vue';

export default {
  name: 'ParticipateForm',
  components: {
    FormSuccessMessage,
    BaseInput,
    BaseButton,
  },
  props: {
    eventType: String,
    formClasses: String,
    formId: String,
    formTextButton: String,
    formEvent: String,
    fieldNames: String,
    telegramLink: String,
    formSuccessMessageProps: {
      type: Object,
      default: null,
    },
    xsrfToken: String,
  },
  data() {
    return {
      form: {
        _xsrf: this.xsrfToken,
        type: this.formEvent,
      },
      isSubmittedError: false,
      isFormSent: false,
      isFormSending: false,
    };
  },
  watch: {
    'form.client_status': function (newVal) {
      this.form.client_status = newVal ? 'on' : '';
    },
  },
  computed: {
    formBlock() {
      return this.$refs?.form.closest('.form-block');
    },
    xsrfFormHtml() {
      return FormUtils.xsrfFormHtml(this.xsrfToken);
    },
  },
  mounted() {
    this.form = FormUtils.createFormData(this.fieldNames, this.form);
  },
  methods: {
    showThisField(name) {
      return this.fieldNames.includes(name);
    },
    findEmptyField() {
      const excludedFields = ['_xsrf', 'type', 'roistat', 'client_status'];
      return FormUtils.findEmptyField(this.form, excludedFields, this.$refs);
    },

    isObjectEmpty(obj) {
      return Object.keys(obj).length === 0;
    },

    redirect() {
      FormUtils.redirectToThankYouPage();
    },

    handleError() {
      this.isFormSending = false;
      this.isSubmittedError = true;
    },

    async handleSuccess() {
      if (this.formBlock) {
        this.formBlock.classList.add('is-success');
      }
      window.submitEventForm();

      await fetch('/events/roistat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ visit: roistat.visit }),
      });

      if (this.eventType === 'premier') {
        this.$refs.formSuccessMessage.show();
        return;
      }

      this.isFormSending = false;
      this.isFormSent = true;

      this.redirect();
    },

    submitForm() {
      this.isFormSending = true;
      const url = '/subscribe';

      FormUtils.submitForm(url, this.form, this.handleSuccess.bind(this), this.handleError.bind(this));
    },
    onSubmit(e) {
      e.preventDefault();

      if (!this.findEmptyField()) {
        this.submitForm();
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;

.input {
  border: initial;
}

.input,
.button {
  height: initial;
}
.error-message {
  @include mixins.font(1.5rem, 1.55);

  display: inline-block;
  margin-bottom: 1.2rem;
  color: #ff5b5b;

  @include mixins.media(md) {
    @include mixins.font(1.9rem, 1.45);
  }
}
</style>
